import { useLocalSearchParams } from 'expo-router';

import { DeferredRedirect } from '../../../../../routing';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  const params = useLocalSearchParams<{ giftCardId: string }>();

  return <DeferredRedirect href={{ pathname: '/account/gift/redeem/[giftCardId]', params }} />;
}
